module.exports = __webpack_public_path__ + "static/media/user.9d0dba72.svg";